import * as React from "react";
import {
    useQueryTable,
    ClearFiltersAction
} from "../misc/components/queryTable/Hooks/UseQueryTable";
import { QueryOrderDirection } from "../misc/api/apiTypes";
import DocumentTitle from "../misc/components/DocumentTitle";
import { AuditTrailListTable } from "./AuditTrailListTable";
import { Route, Switch } from "react-router";
import { AuditTrailIndividualViewScreen } from "./AuditTrailIndividualViewScreen";

export const AuditTrailScreen = () => {
    const queryTableReducer = useQueryTable({
        query: {
            Order: {
                Member: "EventDateTime",
                Direction: QueryOrderDirection.Descending
            },
            Page: {
                Current: 1,
                Length: 10
            },
            Filters: []
        }
    });
    const [_, dispatch] = queryTableReducer;

    const clearAllFilters = () => {
        dispatch(ClearFiltersAction.create());
    };

    const auditTrailListScreen = () => {
        return (
            <>
                <DocumentTitle title="Audit Trail | Vitalograph Web Portal">
                    <div className="row">
                        <div className="col-md-6">
                            <h2 className="text-primary">Audit Trail</h2>
                        </div>
                        <div className="col-md-6">
                            <div className="h2 pull-right">
                                <button className="btn btn-primary" onClick={clearAllFilters}>
                                    Clear All Filters
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="panel panel-default">
                                <div className="panel-body">
                                    <div className="table-responsive">
                                        <AuditTrailListTable
                                            queryTableReducer={queryTableReducer}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </DocumentTitle>
            </>
        );
    };

    return (
        <Switch>
            <Route path="/Audit" exact>
                {auditTrailListScreen}
            </Route>
            <Route path="/Audit/Event/:id" component={AuditTrailIndividualViewScreen} />
        </Switch>
    );
};
